var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['right-arrow-text', _vm.wrapperClass]},[_c('div',{staticClass:"inner-box",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('i',{class:['icon icon-bor-arrow-right text-primary pl-2', _vm.iconClass]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }